import { HStack } from '@chakra-ui/react';
import { useResendListingReportShareLinkMutation } from '@client/graphql/__generated__/main-operations';
import { useLocation } from 'react-router';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { ListingPageContent } from '../../components/Listings/ListingPage/ListingPageContent/ListingPageContent';
import {
  ListingPageContext,
  ListingPageProvider,
} from '../../components/Listings/ListingPage/ListingPageContext';
import { useRegisteredRoles } from '../../hooks/useRegisteredRoles';
import { SharedPage } from '../SharedPage/SharedPage';

export const SharedListingPage = () => {
  const { isRegisteredAgent } = useRegisteredRoles();
  const location = useLocation();
  const [resendListingReportShareLink, { loading }] =
    useResendListingReportShareLinkMutation();

  const resendLink = async (token: string) => {
    await resendListingReportShareLink({ variables: { token } });
  };

  const isPreview = location.pathname.includes('preview') && isRegisteredAgent;

  const listingPage = (
    <ListingPageProvider isViewOnly={true}>
      <HStack
        alignItems="center"
        backgroundColor="bg.main"
        flexGrow={0}
        gap={0}
        minWidth="100vw"
        mx="auto"
      >
        <ListingPageContext.Consumer>
          {({ isLoadingListing }) => {
            return isLoadingListing ? (
              <CenterSpinner />
            ) : (
              <ListingPageContent />
            );
          }}
        </ListingPageContext.Consumer>
      </HStack>
    </ListingPageProvider>
  );

  return isPreview ? (
    listingPage
  ) : (
    <SharedPage isResendingLink={loading} resendLink={resendLink}>
      {listingPage}
    </SharedPage>
  );
};
